"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PROD_THEMES = exports.MOBILE_THEMES = exports.ALL_THEMES = void 0;
var _filterObject = _interopRequireDefault(require("./utils/filterObject"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ALL_THEMES = {
  sap_horizon: {
    name: 'SAP Horizon Morning',
    package: '@concur/ui-theming',
    less_vars: '/themes/sap_horizon/less_variables.less',
    css_vars: '/themes/sap_horizon/css_variables.css'
  },
  sap_horizon_dark: {
    name: 'SAP Horizon Evening',
    package: '@concur/ui-theming',
    less_vars: '/themes/sap_horizon_dark/less_variables.less',
    css_vars: '/themes/sap_horizon_dark/css_variables.css'
  },
  sap_horizon_hcw: {
    name: 'SAP Horizon High Contrast White',
    package: '@concur/ui-theming',
    less_vars: '/themes/sap_horizon_hcw/less_variables.less',
    css_vars: '/themes/sap_horizon_hcw/css_variables.css'
  },
  sap_horizon_hcb: {
    name: 'SAP Horizon High Contrast Black',
    package: '@concur/ui-theming',
    less_vars: '/themes/sap_horizon_hcb/less_variables.less',
    css_vars: '/themes/sap_horizon_hcb/css_variables.css'
  },
  concur_gateway: {
    name: 'Concur Gateway',
    package: '@concur/ui-theming',
    less_vars: '/themes/concur_gateway/less_variables.less',
    css_vars: '/themes/concur_gateway/css_variables.css'
  },
  sap_fiori_3: {
    name: 'SAP Fiori Light',
    package: '@concur/ui-theming',
    less_vars: '/themes/sap_fiori_3/less_variables.less',
    css_vars: '/themes/sap_fiori_3/css_variables.css'
  },
  sap_fiori_3_dark: {
    name: 'SAP Fiori Dark',
    package: '@concur/ui-theming',
    less_vars: '/themes/sap_fiori_3_dark/less_variables.less',
    css_vars: '/themes/sap_fiori_3_dark/css_variables.css'
  },
  sap_fiori_3_hcw: {
    name: 'SAP Fiori High Contrast White',
    package: '@concur/ui-theming',
    less_vars: '/themes/sap_fiori_3_hcw/less_variables.less',
    css_vars: '/themes/sap_fiori_3_hcw/css_variables.css'
  },
  sap_fiori_3_hcb: {
    name: 'SAP Fiori High Contrast Black',
    package: '@concur/ui-theming',
    less_vars: '/themes/sap_fiori_3_hcb/less_variables.less',
    css_vars: '/themes/sap_fiori_3_hcb/css_variables.css'
  },
  concur_ios: {
    name: 'Concur iOS',
    package: '@concur/ui-theming',
    less_vars: '/themes/concur_ios/less_variables.less',
    css_vars: '/themes/concur_ios/css_variables.css',
    mobile_only: true
  },
  concur_android: {
    name: 'Concur Android',
    package: '@concur/ui-theming',
    less_vars: '/themes/concur_android/less_variables.less',
    css_vars: '/themes/concur_android/css_variables.css',
    mobile_only: true
  }
};
exports.ALL_THEMES = ALL_THEMES;
var MOBILE_THEMES = (0, _filterObject.default)(ALL_THEMES, function (key, value) {
  return value === null || value === void 0 ? void 0 : value.mobile_only;
});
exports.MOBILE_THEMES = MOBILE_THEMES;
var PROD_THEMES = (0, _filterObject.default)(ALL_THEMES, function (key, value) {
  return !(value !== null && value !== void 0 && value.mobile_only) && !value.dev_only;
});

// STANDARD_THEMES exported as the default
exports.PROD_THEMES = PROD_THEMES;
var _default = (0, _filterObject.default)(ALL_THEMES, function (key, value) {
  return !(value !== null && value !== void 0 && value.mobile_only);
});
exports.default = _default;